var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-block"},[_c('div',{staticClass:"img-container"},[(_vm.pic)?_c('v-img',{attrs:{"src":_vm.pic,"alt":"...","aspect-ratio":"1"}}):_vm._e()],1),_c('Favor',{attrs:{"biz":_vm.biz}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }